import { useEffect, useRef } from 'react'
import { useFetcher, useLocation } from '@remix-run/react'
import { useForm, useInputControl } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import z from 'zod'
import { UserDTO } from '~/domain/user/dto/UserDTO'
import { SponsorRequestActionKeys } from '~/domain/sponsorRequest/constants/SponsorRequestActionKeys'

export interface Props {
  isOpen: boolean
  onClose: () => void
  user: UserDTO
}

export const useSponsorRequestModal = (props: Props) => {
  const fetcher = useFetcher()
  const refSubmitButton = useRef<HTMLButtonElement>(null)
  const location = useLocation()
  const { isOpen, user, onClose } = props
  const [form, data] = useForm({
    defaultValue: {
      message: '',
    },
    onValidate({ formData }) {
      formData.append('_action', SponsorRequestActionKeys.create)
      formData.append('redirectUrl', location.pathname)

      return parseWithZod(formData, {
        schema: z.object({
          message: z.string({ required_error: 'メッセージを入力してください' }),
        }),
      })
    },
  })
  const controls = {
    message: useInputControl(data.message),
  }
  const onClickSend = () => {
    refSubmitButton.current?.click()

    if (controls.message.value) {
      onClose()
    }
  }
  const onCloseModal = () => {
    form.reset()
    onClose()
  }

  return {
    isOpen,
    user,
    onClose: onCloseModal,
    fetcher,
    data,
    controls,
    form,
    action: SponsorRequestActionKeys.create,
    redirectUrl: location.pathname,
    refSubmitButton,
    onClickSend,
  }
}
